import ArrowBackRoundedIcon from '@mui/icons-material/ArrowBackRounded'
import { Button, Stack, Typography } from '@mui/material'
import { useTranslation } from 'hooks/useTranslation'
import OtpForm from 'modules/authentication/components/OtpForm'
import useAuthenticationContext from 'modules/authentication/hooks/useAuthenticationContext'
import { useEffect, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { useAuthenticate2FA } from 'services/api/iam/manager/mutations/useAuthenticate2FA'

export default function TwoFactorAuth() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const [invalidCode, setInvalidCode] = useState(false)
  const {
    token: [token, setToken]
  } = useAuthenticationContext()
  const { mutateAsync, isLoading } = useAuthenticate2FA({
    onSuccess(data) {
      setToken(data)
      navigate('/choose-account')
    },
    onError() {
      setInvalidCode(true)
    }
  })
  const submit = async (code: string) => {
    if (!token?.token || isLoading) return
    await mutateAsync({ token: token.token, sixDigitsCode: code }).catch(() => undefined)
  }
  useEffect(() => {
    if (!token) navigate('/')
  }, [token, navigate])

  return (
    <Stack gap={11.25}>
      <Stack gap={1.25}>
        <Typography variant="h4">{t('Verificação em 2 etapas')}</Typography>
        <Typography variant="subtitle1">{t('Insira o código para acessar o painel')}</Typography>
      </Stack>
      <OtpForm
        busy={isLoading}
        error={invalidCode ? t('O código digitado não é válido') : undefined}
        clearOnSubmit={false}
        onSubmit={submit}
        onChange={() => setInvalidCode(false)}
      >
        <Button
          startIcon={<ArrowBackRoundedIcon />}
          sx={{ alignSelf: 'flex-start' }}
          onClick={() => navigate('/')}
        >
          {t('Voltar')}
        </Button>
      </OtpForm>
    </Stack>
  )
}
